import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const Uninspired = ({ color }) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="nonzero">
      <path d="M11.948 12.037c-2.337 0-2.942 1.803-2.965 1.88a.69.69 0 0 0 1.31.421c0-.01.312-.923 1.655-.923 1.342 0 1.65.914 1.654.923a.69.69 0 0 0 1.313-.421c-.027-.077-.632-1.88-2.967-1.88zM8.524 9.355a.69.69 0 0 0-.689.69.52.52 0 1 1-1.04 0 .69.69 0 0 0-1.38 0 1.9 1.9 0 1 0 3.799 0 .69.69 0 0 0-.69-.69zM17.953 9.355a.69.69 0 0 0-.69.69.521.521 0 0 1-1.04 0 .69.69 0 1 0-1.38 0 1.9 1.9 0 0 0 3.8 0 .69.69 0 0 0-.69-.69z" />
      <path d="M12 .281C5.538.281.281 5.538.281 12S5.538 23.719 12 23.719 23.719 18.462 23.719 12 18.462.281 12 .281zm0 22.06C6.298 22.34 1.66 17.7 1.66 12 1.66 6.298 6.298 1.66 12 1.66S22.34 6.298 22.34 12 17.702 22.34 12 22.34z" />
    </g>
  </svg>
);
Uninspired.defaultProps = {
  color: colors.blue,
};

Uninspired.propTypes = {
  color: PropTypes.string,
};

export default Uninspired;
